


































































import { Component, Vue } from 'vue-property-decorator'
import OptionModule from '@/components/OptionModule.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import { InformationCodes } from '@/data/enums'

@Component({
  components: {
    OptionModule,
    ToggleButton
  },
  computed: {
    impressionist: {
      get (): string {
        if (this.$store.state.cart.currentItem.impressionist === null) return ''
        return (this.$store.state.cart.currentItem.impressionist) ? 'yes' : 'no'
      },
      set (value) {
        const booleanValue = (value === 'yes')
        this.$store.dispatch('cart/setImpressionist', booleanValue)
          .catch((err) => console.error(err))
      }
    }
  }
})
export default class ImpressionistModule extends Vue {
  private informationCode = InformationCodes.ModuleImpressionist
  private video: string = 'module/impressionist/impressionist_video.mp4'
  private get previous (): string {
    let prev = '/glasses/dneye'
    const hasDneye = this.$store.state.data.optician.dneye
    if (!hasDneye) {
      prev = '/glasses'
    }
    return prev
  }
}
